import { Button, ButtonProps } from '@mui/material';
import { colors } from '../theme';

interface CancelButtonProps extends Omit<ButtonProps, 'color'> {
  /** Buton metni (varsayılan: "İptal") */
  children?: React.ReactNode;
}

/**
 * Proje genelinde kullanılan iptal/kapat butonu.
 * Hafif hover, yeşil olmayan tutarlı stil.
 */
const CancelButton: React.FC<CancelButtonProps> = ({
  children = 'İptal',
  size = 'medium',
  sx,
  ...rest
}) => (
  <Button
    color="inherit"
    size={size}
    sx={{
      color: colors.text.secondary,
      textTransform: 'none',
      px: size === 'small' ? 2 : 3,
      py: size === 'small' ? 0.75 : 1,
      borderRadius: 1.5,
      '&:hover': { bgcolor: colors.background.light },
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Button>
);

export default CancelButton;
